module.exports = __webpack_public_path__ + "img/screen7.0342179f.png";